import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/expand.svg'
import _imports_1 from '@/assets/icons/external-link.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "3", -1)
const _hoisted_2 = { class: "order-number" }
const _hoisted_3 = { class: "info-text" }
const _hoisted_4 = { class: "external-link" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "ext-link-icon"
}, null, -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "add-order-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, {
    optClass: "step",
    hidden: _ctx.hidden
  }, {
    "step-number": _withCtx(() => [
      _hoisted_1
    ]),
    "step-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("NEW_TICKET.ADD_NEW_ORDER_NO")), 1)
    ]),
    optional: _withCtx(() => [
      _createElementVNode("img", {
        src: _imports_0,
        class: _normalizeClass(["expand", { hidden: !_ctx.hidden }])
      }, null, 2)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_i18n_t, {
            tag: "p",
            keypath: "NEW_TICKET.NEW_ORDER_TEXT"
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_ctx.t("NEW_TICKET.NEW_ORDER_TEXT_BOLD")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Warning, {
            text: _ctx.t('NEW_TICKET.NEW_ORDER_WARNING')
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("a", {
              href: _ctx.marketUrl,
              target: "_blank",
              class: "ext-link-text"
            }, _toDisplayString(_ctx.t("NEW_TICKET.NEW_WINDOW")), 9, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_CustomInput, {
            insideText: _ctx.newOrderNo,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:newOrderNo', $event.target.value))),
            label: _ctx.t('COMMON.NEW_ORDER_NO'),
            tooltip: true,
            invalid: 
              _ctx.validation.$errors.length ||
                (_ctx.validation.$invalid && _ctx.doneButtonClicked)
            ,
            onBlur: _ctx.validation.$touch
          }, _createSlots({
            tooltipText: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("NEW_TICKET.TOOLTIPS.NEW_ORDER")), 1)
            ]),
            _: 2
          }, [
            (_ctx.validation.$errors.length)
              ? {
                  name: "invalidText",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getInvalidText(_ctx.validation.$errors[0].$validator)), 1)
                  ])
                }
              : (_ctx.validation.$invalid)
                ? {
                    name: "invalidText",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("NEW_TICKET.INVALIDS.INVALID_EMPTY")), 1)
                    ])
                  }
                : undefined
          ]), 1032, ["insideText", "label", "invalid", "onBlur"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["hidden"]))
}